<script setup lang="ts">
import type { PropertyType } from '@/backend/types'
import type { ReviewStatus } from '@/modules/Project/Fields/types'
import { TYPE_ICON } from '@/modules/Project/icons'
import IconSprite from '@/uiKit/IconSprite.vue'

defineProps<{
  name: string
  type: PropertyType
  id: string
  isModelOutput: boolean
  reviewStatus: ReviewStatus | null
}>()
</script>

<template>
  <div class="flex h-7 flex-row items-center gap-2">
    <div class="flex h-full shrink-0 flex-row items-center justify-center">
      <IconSprite
        :icon="TYPE_ICON[type]"
        :class="
          isModelOutput && reviewStatus === null
            ? 'fill-background-stages-model text-background-stages-model'
            : 'fill-icon-subtlest text-icon-subtlest'
        "
      />
    </div>

    <span
      :id="id"
      :title="name"
      class="my-1.5 line-clamp-1 text-sm-12px-default text-text-subtle"
    >
      {{ name }}
    </span>
  </div>
</template>
